// extracted by mini-css-extract-plugin
export default {"pill":"pill_pill__sKt29","rectangular":"pill_rectangular__Y8Wq1","circular":"pill_circular__T--GJ","pill--default":"pill_pill--default__8tIBY"};